import React from 'react';
import { TESTIMONIALS, TESTIMONIALS_INTRO } from '../constants/content';
import { Reveal } from './Reveal';
import { StarRating } from './StarRating';
export function SocialProof() {
  return <section className="w-full bg-cream py-12 b760:py-16" data-id="element-243" data-mp="36w3it1vgoy2k">
      <div className="mx-auto max-w-4xl px-4 b720:px-6" data-id="element-244" data-mp="36xofoy590t3l">
        <Reveal className="text-center" data-id="element-245" data-mp="3bvpxlfqxumdh">
          <h2 className="font-display text-2xl font-700 uppercase leading-tight text-night b640:text-4xl" data-id="element-246" data-mp="3bwr9tnjoxews">
            {TESTIMONIALS_INTRO.title}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-night/75 b640:text-base" data-id="element-247" data-mp="8cwmrapjobn0">
            {TESTIMONIALS_INTRO.sub}
          </p>
        </Reveal>

        <div className="mt-8 grid gap-5 b760:grid-cols-2" data-id="element-248" data-mp="3utj04gxnguac">
          {TESTIMONIALS.map((testimonial, index) => <Reveal key={testimonial.name} delay={index % 2 * 80} data-id="element-249" data-mp="mdz81l8pthwv" data-mpi={index}>
              <figure className="h-full rounded-2xl border border-night/10 bg-white p-5 b640:p-6" data-id="element-250" data-mp="mbmmyz7nurfl">
                <StarRating className="text-mustard" size={16} data-id="element-251" data-mp="r6aaovuubht4" />
                <figcaption className="mt-3 font-display text-lg font-700 text-bordo b640:text-xl" data-id="element-252" data-mp="1uammbutxxlxw">
                  {testimonial.title}
                </figcaption>
                <blockquote className="mt-3 text-sm leading-relaxed text-night/85 b640:text-base" data-id="element-253" data-mp="24066r4xaxnuv">
                  {testimonial.quote}
                </blockquote>
                <div className="mt-4 flex items-center gap-3" data-id="element-254" data-mp="1z738ijhkxq8c">
                  <img src={testimonial.img} alt={`Foto de ${testimonial.name}`} width={48} height={48} loading="lazy" decoding="async" className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-mustard/50" data-id="element-255" data-mp="2cz1925x86dsw" />
                  <p className="text-sm font-700 text-night" data-id="element-256" data-mp="sjpm8x6w4h15">
                    {testimonial.name}
                    <span className="ml-2 font-400 text-night/60" data-id="element-257" data-mp="nm6ac3xo0gcd">
                      {testimonial.location}
                    </span>
                  </p>
                </div>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}